import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(() => ({
  errorMessage: {
    color: Theme.Colors.Red.Base,
  },
}))
